.successIcon {
  border-radius: 50%;
}
